<script>
	import { dayjs } from '@woltair/translations-package-fe'
	import { INSTALLATION_CATEGORY, REGIONS, getAttrFromConst } from '$lib/consts'
	import { HEAT_PUMP, PHOTOVOLTAICS } from '$lib/routes'
	import { t } from '$lib/translations'

	export let title = {
		text: t('references.thumbnails.title'),
		textAlign: 'left'
	}
	export let references = []
	export let detailText = 'Zobrazit detail'
	export let referencesOnlyImages = false
	export let background = ''
	export let overflowPage = false
	export let titleFontSize = '2xl'
	export let titleWeight = ''
	export let noPaddingLeft = false
	export let noDetail = false
	export let padding = ''

	const DEVICE_URL = {
		[INSTALLATION_CATEGORY.TEPELNE_CERPADLO]: HEAT_PUMP,
		[INSTALLATION_CATEGORY.FOTOVOLTAIKA]: PHOTOVOLTAICS
	}

	const getReferenceURL = (ref) => {
		const category = ref.order.installationOrder?.category
		const region = ref.order.location?.address?.region

		return category && region
			? DEVICE_URL[category] +
					'/' +
					getAttrFromConst(REGIONS.WOLTAIR_CZ, 'value', ref.order.location?.address.region, 'url') +
					'#ref' +
					ref.order.uid
			: null
	}
</script>

<div class="wrapper {background}" class:overflow-page={overflowPage}>
	{#if title.text}
		<h4
			class="unstyled mb-2 lg:max-w-[32vw] text-{titleFontSize} font-{titleWeight} text-{title.textAlign} {padding}"
			class:!pl-0={noPaddingLeft}
		>
			{title.text}
		</h4>
	{/if}
	<div class="thumbnails flex gap-4" class:!pl-0={noPaddingLeft}>
		{#each references as reference}
			{@const src = reference.resources[0]?.url}
			{@const refURL = getReferenceURL(reference)}
			{#if src}
				<div class="thumbnail block bg-white {referencesOnlyImages ? 'thumbnail_smaller' : ''}">
					<div class="img-cont overflow-hidden">
						<img {src} alt="Produkt-{reference.order.uid}" />
					</div>
					<div class="text-cont my-3">
						<p class="unstyled mb-0 mt-0 text-left !font-normal text-neutral-800 lg:text-base">
							{reference?.city || reference.order?.location?.address?.city || 'ČR'}
						</p>
						{#if !referencesOnlyImages}
							<div class="container-flex">
								<p class="unstyled text-gray my-0 text-xs !font-light">
									{dayjs(reference?.createdAt).fromNow()}
								</p>
							</div>
						{/if}
					</div>
					{#if !referencesOnlyImages && refURL && !noDetail}
						<hr />
						<a href={refURL} class="flex items-center justify-between px-3 py-2">
							<span class="bold text-xs">{detailText}</span>
							<img
								class="icon inline-block h-3 w-5"
								src="/images/icons/arrow/next-black.svg"
								alt="arrow"
							/>
						</a>
					{/if}
				</div>
			{/if}
		{/each}
	</div>
</div>

<style lang="scss">
	.wrapper {
		position: relative;
		/*margin: 30px 0 0;
		padding: 30px 0 0;*/

		&:not(&.overflow-page) {
			width: calc(100% + 60px);
			left: -30px;

			@media (max-width: 760px) {
				left: -15px;
				width: calc(100% + 30px);
			}
		}

		h4 {
			padding: 0 30px;
		}

		.thumbnails {
			overflow-x: auto;
			-ms-overflow-style: none;
			scrollbar-width: none;
			padding: 20px 30px 40px;

			&::-webkit-scrollbar {
				display: none;
			}

			.thumbnail {
				flex-shrink: 0;
				width: 250px;
				min-height: 220px;
				//box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
				padding: 1.25rem 0.75rem 0.75rem 0.75rem;
				&.thumbnail_smaller {
					height: 194px;
				}
				box-sizing: border-box;
				overflow: hidden;

				.img-cont {
					width: 100%;
					height: 150px;
					margin: 0;
					img {
						display: block;
						width: 100%;
						height: 100%;
						object-fit: cover;
					}
				}

				.text-cont {
					overflow: hidden;

					p {
						white-space: nowrap;

						&:first-child {
							font-weight: 500;
						}
					}
				}
			}
		}
	}
</style>
